import React, { useEffect } from "react";
import { useState } from "react";
import StudentChapter from "./StudentChapter";

function Detail({ classDetail }) {
  const [activeClass, setActiveClass] = useState([]);
  const [allChapter, SetAllChapter] = useState([]);
  const [completedChapter, setCompletedChapter] = useState([]);
  const [studentForId, setStudentForId] = useState();
  const [selectedUnit, setSelectedUnit] = useState(null);
  // console.log("class detail", classDetail);
  useEffect(() => {
    setActiveClass(classDetail.updatedIstatikArray);
    setCompletedChapter(classDetail.classScoreArray);
    SetAllChapter(classDetail.classTaskArray);
    setStudentForId(classDetail.studentId);
  }, [classDetail]);

  const handleSelectChapter = (value) => {
    setSelectedUnit(value);
  };
  return (
    <div className="mb-8 px-4">
      <div className="bg-transparent rounded-xl  overflow-hidden">
        <div className="p-6">
          {/* Ödev İstatistikleri */}
          <div className="flex flex-col gap-4">
            <div className="flex  gap-4 justify-center md:justify-start overflow-x-scroll overflow-y-hidden pb-2">
              {activeClass.length > 0 ? (
                activeClass.map((item, index) => {
                  const percentage = Math.round(
                    (item.completedtask / item.totalUnites) * 100,
                  );
                  const isSelected = selectedUnit === item.unites;
                  return (
                    <div
                      key={index}
                      onClick={() => handleSelectChapter(item.unites)}
                      className={`group cursor-pointer transition-all duration-300 hover:scale-105 ${
                        isSelected ? "scale-105" : ""
                      }`}
                    >
                      <div
                        className={`flex justify-center items-center gap-3 p-4 rounded-xl ${
                          isSelected
                            ? "bg-purple-500 shadow-xl"
                            : "bg-gray-100 shadow-md hover:shadow-lg"
                        }`}
                      >
                        {/* bu soldaki button chapter sayısını gösterir */}
                        <div className="relative">
                          <button
                            className={`relative w-12 h-12 flex flex-col items-center justify-center
                            rounded-full text-white transition-all duration-300 ${
                              isSelected
                                ? "bg-yellow-500"
                                : "bg-gradient-to-br from-purple-500 to-purple-600 hover:from-purple-600 hover:to-purple-700"
                            }`}
                          >
                            <span className="text-lg">
                              {item.completedtask}
                            </span>
                            <hr className="border border-white w-6" />
                            <span className="text-xs opacity-75">
                              {item.totalUnites}
                            </span>
                          </button>
                        </div>

                        <div className="flex flex-col gap-1">
                          <p className="text-sm text-gray-800 text-center max-w-[120px] leading-tight">
                            {item.unites || `Kategori ${index + 1}`}
                          </p>
                          <div className="w-full bg-gray-200 rounded-full h-1.5">
                            <div
                              className={`h-1.5 rounded-full transition-all duration-500 ${
                                percentage === 100
                                  ? "bg-green-500"
                                  : percentage >= 50
                                    ? "bg-yellow-500"
                                    : "bg-gray-400"
                              }`}
                              style={{ width: `${percentage}%` }}
                            ></div>
                          </div>
                        </div>
                      </div>

                      {/* Yüzde göstergesi - group-hover ile kontrol */}
                      <div
                        className={`ml-40 -mt-5 w-8 h-8 rounded-full flex items-center
                            justify-center text-xs font-bold shadow-md z-60 
                            opacity-0 group-hover:opacity-100 transition-opacity duration-200 ${
                              percentage === 100
                                ? "bg-green-500 text-white"
                                : percentage >= 50
                                  ? "bg-yellow-500 text-white text-[10px] font-normal"
                                  : "bg-yellow-500 text-white text-[10px] font-normal"
                            }`}
                      >
                        {percentage}%
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="col-span-3 text-center p-8 bg-gray-100 rounded-lg w-full">
                  <p className="text-gray-600">Henüz kategori bulunmuyor.</p>
                </div>
              )}
            </div>
            <StudentChapter
              selectedUnit={selectedUnit}
              completedChapter={completedChapter}
              allChapter={allChapter}
              studentForId={studentForId}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Detail;
